import Navigo from 'navigo';
import {
  IAppLoaderNavigationService,
  RouteID,
  RouterActions,
} from '../../types/features/navigation/navigation-types';
import { routesConfig } from './routes-config';

class NavigationService implements IAppLoaderNavigationService {
  private router: Navigo;

  constructor() {
    this.startLegacyHashNormalization();
    this.router = new Navigo(RouteID.ROOT, { hash: true });
  }

  private startLegacyHashNormalization() {
    window.addEventListener('popstate', () => {
      const path = window.location.hash.replace('#', '');
      if (path && !path.startsWith('/')) {
        window.history.replaceState(
          {},
          document.title,
          window.location.href.replace(/#.*$/, '') + '#/' + path,
        );
      }
    });
  }

  initRouter(routerActions: RouterActions) {
    routesConfig.forEach(routeConfig => {
      if (routeConfig.id === RouteID.NOT_FOUND) {
        return;
      }

      this.router.on(routeConfig.id, match => {
        const params = routeConfig.handler.paramsParser?.({
          data: match?.data ?? null,
          queryString: match?.params as Record<string, string> | undefined,
        });
        routerActions.navigateToRoute(routeConfig.id, params);
      });
    });

    this.router.notFound(() => {
      routerActions.navigateToRoute(RouteID.ROOT);
    });

    this.router.resolve();
  }

  getPath(routeID: RouteID) {
    return routeID;
  }

  navigate(path: RoutePath, triggerPathHandler?: boolean) {
    // window.history.pushState(null, '', path);
    const callHandlerTrigger = triggerPathHandler === undefined ? true : triggerPathHandler;
    this.router.navigate(path, { callHandler: callHandlerTrigger }); //TODO почему не работает как ожидается? А как ожидается? Да хз
  }

  destroy() {
    this.router.destroy();
  }

  navigateReplacing(path: RoutePath) {
    window.history.replaceState({}, document.title, '/#' + path);
    this.navigate(path);
  }

  changeUrl(url: Url) {
    location.href = url;
  }

  reload() {
    location.reload();
  }

  openUrl(url: Url, target?: UrlTarget) {
    window.open(url, target);
  }

  getPathFromWindowHash() {
    return window.location.hash.replace('#', '') as RoutePath;
  }

  openFile(url: Url | UrlPath) {
    window.open(url);
  }

  copyToBuffer(value: string): Promise<void> {
    return navigator.clipboard.writeText(value);
  }
}

export { NavigationService };
